module.exports = __webpack_public_path__ + "static/media/dataAnalysis.88f0225a.jpg";